<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    }
  },
  components: {
    
  },
  created() {

  }
}
</script>

<style>
#app {
  font-family: 'Source Han Sans CN', sans-serif;
  /* font-family: 'ZCOOL QingKe HuangYou', cursive; */
  
}
body {
  /* background-color: #FAFAFA; */
  padding: 0;
  margin: 0;
}
</style>
